module.exports = __webpack_public_path__ + "img/TechLoom1_ua.cfbf0c44.webp";